// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"_1EyKEr","initialPrice":"_1YpRdU","finalPrice":"_3AOL-o","savedPrice":"_2ImLnP"};